import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { api } from '../../api/endpoints';

const describe = (detail: Record<string, unknown>) =>
  Object.entries(detail)
    .filter(([k]) => k !== 'route')
    .map(([k, v]) => `${k}=${String(v)}`)
    .join(' · ');

/** Admin-only log of every account's logins, terms acceptances, searches and downloads (#170). */
function ActivityPage() {
  const [userId, setUserId] = useState('');
  const [kind, setKind] = useState('');
  const users = useQuery({ queryKey: ['admin-users'], queryFn: api.adminUsers });
  const activity = useQuery({
    queryKey: ['admin-activity', userId, kind],
    queryFn: () =>
      api.adminActivity({
        limit: '500',
        ...(userId ? { user_id: userId } : {}),
        ...(kind ? { kind } : {}),
      }),
  });
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h5" component="h1" gutterBottom>
        Activity
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
        <TextField
          select
          size="small"
          label="User"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          sx={{ minWidth: 260 }}
        >
          <MenuItem value="">Everyone</MenuItem>
          {(users.data?.users ?? []).map((u) => (
            <MenuItem key={u.id} value={u.id}>
              {u.email}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          size="small"
          label="Kind"
          value={kind}
          onChange={(e) => setKind(e.target.value)}
          sx={{ minWidth: 160 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="login">Logins</MenuItem>
          <MenuItem value="terms_accept">Terms accepted</MenuItem>
          <MenuItem value="search">Searches</MenuItem>
          <MenuItem value="download">Downloads</MenuItem>
        </TextField>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>When (UTC)</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Kind</TableCell>
              <TableCell>What</TableCell>
              <TableCell>IP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(activity.data?.activity ?? []).map((e) => (
              <TableRow key={e.id}>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {e.at.slice(0, 19).replace('T', ' ')}
                </TableCell>
                <TableCell>{e.email}</TableCell>
                <TableCell>{e.kind}</TableCell>
                <TableCell>
                  {typeof e.detail.route === 'string' ? `${e.detail.route} ` : ''}
                  {describe(e.detail)}
                </TableCell>
                <TableCell>{e.ip ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export const Route = createFileRoute('/admin/activity')({ component: ActivityPage });
